const jorgeData = {
  experience: [
    {
      iconName: "RiUserHeartLine",
      text: "Jorge Rosende, *Psicólogo Clínico* y *Psicoterapeuta*, con más de *15 años de experiencia* atendiendo pacientes en consulta particular, desde el *Modelo de Psicoterapia Posracionalista Ontológico*.",
    },
    {
      iconName: "RiUserSettingsLine",
      text: "*Experiencia Docente* en diversas cátedras de la *Carrera de Psicología*, en el área de formación específica de psicología clínica y psicoterapia, a estudiantes de pregrado y postgrado, y en práctica profesional, en varias universidades del país.",
    },
    {
      iconName: "RiUserSettingsLine",
      text: "*Profesor Titular en Pregrado*: Enfoque y Estrategias Psicoterapéuticas (psicoterapias cognitivas); Diagnóstico Clínico; Introducción a la Psicoterapia; Teorías Psicológicas I y II (Enfoques cognitivo, psicoanalítico, sistémico y humanista); Psicoterapia Estratégica Breve; Fundamentos Psicológicos (enfoque cognitivo); Taller de Desarrollo Personal; y Electivo de Formación General (manejo del estrés y autocuidado).",
    },
    {
      iconName: "RiUserSettingsLine",
      text: "*Supervisor Clínico Titular en Pregrado*: Estudiantes de la Carrera de Psicología en práctica profesional (área clínica).",
    },
    {
      iconName: "RiUserSettingsLine",
      text: "*Ayudante y Co - Supervisor Clínico en Postgrado*: Estudiantes de Magíster de psicología clínica en cátedra y práctica profesional (área clínica y psicoterapia).",
    },
    {
      iconName: "RiUserSettingsLine",
      text: "*Ayudante de Cátedra en Pregrado*: Neurofisiología; Técnicas de Manejo Individual y Grupal; Psicología Clínica y Asistencial (psicoterapia posracionalista).",
    },
    {
      iconName: "RiUserSettingsLine",
      text: "*Integrante de Comisiones Evaluadoras*, en calidad de *Docente Experto*, en el área de psicología clínica y psicoterapia, en los procesos de exámenes conducentes al título profesional de psicólogo.",
    },
    {
      iconName: "RiUserSettingsLine",
      text: "*Supervisor Clínico Particular*: Psicólogos titulados, impartiendo formación teórico - práctica, y supervisando casos clínicos, en modalidad individual y grupal, desde el modelo de psicoterapia posracionalista.",
    },
    {
      iconName: "RiUserSettingsLine",
      text: "*Investigaciones científicas* y *artículos*, en el área de la psicología clínica y psicoterapia.",
    },
    {
      iconName: "RiUserFollowLine",
      text: "Empático, comprensivo y ausencia de juicios de valor hacia el paciente.",
    },
    { iconName: "RiUserFollowLine", text: "Enriquecido en autoconocimiento." },
    {
      iconName: "RiUserFollowLine",
      text: "Profesional, responsable y comprometido.",
    },
    {
      iconName: "RiUserFollowLine",
      text: "Respeto y aceptación hacia la problemática del paciente.",
    },
    {
      iconName: "RiUserFollowLine",
      text: "Respeto hacia la puntualidad y tiempos personales del paciente.",
    },
    {
      iconName: "RiUserFollowLine",
      text: "Mantengo una actualización constante en el desarrollo de nuevos conocimientos teóricos, metodológicos y técnicas en el ámbito de la psicología clínica y psicoterapia.",
    },
    {
      iconName: "RiUserFollowLine",
      text: "He *realizado procesos de psicoterapia*, con la finalidad de poder crecer tanto en lo personal como en lo profesional, puesto que es fundamental e influye directamente en una mejor práctica clínica al momento de atender pacientes. En la misma dirección, he cumplido con los requisitos formales mínimos de horas realizando el trabajo de “*la Persona del Terapeuta*”, en instancias de entrenamientos clínicos y formaciones de postítulos y postgrados, que se exigen para obtener acreditaciones posteriores.",
    },
    {
      iconName: "TbAward",
      text: "*Acreditación Nacional como Psicólogo Clínico: Especialista en Psicoterapia*, por cumplir con todos los requisitos de formación de post - título y experiencia profesional, exigidos por la Comisión Nacional de Acreditación de Psicólogos Clínicos *(CONAPC)*, por el *Colegio de Psicólogos de Chile A.G.*  y por la Sociedad Chilena de Psicología Clínica *(SCPC) *.",
    },
    {
      iconName: "TbAward",
      text: "*Acreditación internacional: Certificado Latinoamericano de Psicoterapeuta*, en virtud de haber cumplido con los requisitos de formación y práctica profesional altamente calificada, exigidos por la Federación Latinoamericana de Psicoterapia *(FLAPSI)* y avalado por World Council for Psychotherapy *(WCP)*.",
    },
    {
      iconName: "TbAward",
      text: "Membresía *Colegio de Psicólogos de Chile A.G.*",
    },
    {
      iconName: "TbAward",
      text: "Membresía Sociedad Chilena de Psicología Clínica y Psicoterapia *(SCPC)*.",
    },
    {
      iconName: "TbAward",
      text: "*Fundador* y *Director* de la sección *“Más allá de la psicoterapia”*, de la revista *“El Encuentro”*, de la Universidad Autónoma de Chile. Premiado por la universidad por su activa participación en la elaboración de artículos para la revista y el apoyo e incentivo a los estudiantes para que realicen publicaciones en la misma.",
    },
    {
      iconName: "TbAward",
      text: `*Vocero Oficial* de la Escuela de Psicología de la Universidad Central de Chile y de la Universidad Autónoma de Chile, siendo invitado como panelista y realizando entrevistas a diversos medios de comunicación, tales como: 
      Programas nacionales y *noticieros* de televisión en: Canal 13, Mega, TVN, La Red, CHV, CNN Chile, e Internacionales: NTN24 Colombia. 
      *Programas de Radios*: Radio Bío-Bío, Radio Agricultura, Radio ADN, Radio Cooperativa, Radio Futuro, Radio Horizonte, Radio Amadeus Fm, Radio Oasis y Radio Digital-FM.
      *Periódicos*: La Tercera, El Mercurio, Las Últimas Noticias, La Nación y Publimetro. 
      *Medios Digitales Escritos*: BBC Mundo Latino América, Terra y Columna Digital. 
      *Revistas científicas*: Revista In Vitro. 
      `,
    },
    {
      iconName: "TbAward",
      text: "*Expositor en el 14° Congreso Chileno de Psicoterapia* y *12° Congreso de Investigación en Psicoterapia*, realizado en el Hotel Conference Town de Reñaca, Viña del Mar, presentando la ponencia: *Terapia dialógica: narrativa y cambios de significados durante el proceso psicoterapéutico, en una consultante con sintomatología depresiva*.",
    },
    {
      iconName: "TbAward",
      text: "*Expositor en el Seminario Clínico Académico*, realizado en la Facultad de Ciencias Sociales de la Universidad Central de Chile, presentando el tema: *El Modelo Posracionalista en Psicoterapia*.",
    },
    {
      iconName: "TbAward",
      text: "*Expositor en el Simposio*, realizado en la Universidad Autónoma de Chile, presentando el tema: *Despatologización en Psicoterapia*.",
    },
    {
      iconName: "TbAward",
      text: "*Expositor en el Seminario Académico*, realizado en el Instituto Profesional de Chile, IPCHILE, presentando la temática: *Estrategias para la incorporación cultural del constructivismo en educación*.",
    },
  ],
  studies: [
    {
      iconName: "FaGraduationCap",
      text: "*Licenciado en psicología* y *titulado de psicólogo*, mención en clínica, *Universidad Central de Chile*, Facultad de Ciencias Sociales (*Distinción Máxima*).",
    },
    {
      iconName: "FaGraduationCap",
      text: "*Práctica profesional*, en el Centro de Atención Psicológica y Estudios (*CAPSE*) y en el Centro de Atención Psicológica Vespucio (*CAP-V*), de la Universidad Central de Chile (Campus La Reina).",
    },
    {
      iconName: "FaGraduationCap",
      text: "*Postgrado de Magíster en Psicología Clínica*, mención en psicoterapia constructivista y construccionista, Facultad de Medicina, *Universidad de Valparaíso* (*Distinción Máxima*).",
    },
    {
      iconName: "FaGraduationCap",
      text: "*Postítulo Internacional en Psicoterapia Posracionalista*, Centro de Terapia Posracionalista, *CETEPO Roma, Italia*. 470 horas de formación. Dirigido por el *Doctor Juan Balbi*.",
    },
    {
      iconName: "FaGraduationCap",
      text: "*Diplomado en Psicoterapia Cognitiva Posracionalista Ontológica (actualizaciones en la teoría y el método)*, Centro de Terapia Posracionalista, *CETEPO Chile*, 200 horas de formación. Dirigido por el *Doctor Juan Balbi*. ",
    },
    {
      iconName: "FaGraduationCap",
      text: "Workshop: *“La práctica clínica en la terapia posracionalista”. *Doctor Juan Balbi.* Centro de Terapia Posracionalista (CETEPO, Chile).",
    },
    {
      iconName: "FaGraduationCap",
      text: "Curso: *Terapia focalizada en la emoción: El efecto transformador del afecto, Doctor Leslie Greenberg*. Centro de Terapia Posracionalista (Cetepo, Argentina) y Universidad de Buenos Aires.",
    },
    {
      iconName: "FaGraduationCap",
      text: "Curso: Entrenamiento intensivo en psicoterapia: *El uso creativo de la estrategia posracionalista en la reconstrucción de la trama narrativa*. Sociedad Chilena de Psicología y Psicoterapia Constructivista.",
    },
    {
      iconName: "FaGraduationCap",
      text: "Curso: Entrenamiento intensivo en psicoterapia: *Manejo de duelo: Una mirada constructivista - cognitiva*. Sociedad Chilena de Psicología y Psicoterapia Constructivista.",
    },
    {
      iconName: "FaGraduationCap",
      text: "Curso práctico de psicoterapia: *Personalidad con tendencia a las obsesiones - compulsiones. Abordaje desde el modelo posracionalista*, Doctor David Trujillo. Sociedad de Terapia Cognitiva Posracionalista (STCP) y Universidad Adolfo Ibáñez.",
    },
    {
      iconName: "FaGraduationCap",
      text: "Curso: *Mapas de terapias narrativas*, Doctora Marcela Polanco. Universidad de Valparaíso.",
    },
    {
      iconName: "FaGraduationCap",
      text: "Curso: *Vínculo de apego a lo largo de la vida*. Universidad Central de Chile.",
    },
    {
      iconName: "FaGraduationCap",
      text: "Curso: *Psicoterapia cognitivo - conductual orientada a los trastornos del ánimo, ansiedad y sexuales*. Universidad Central de Chiile.",
    },
    {
      iconName: "FaGraduationCap",
      text: "Curso: *Neuropsicología clínica y evaluación neuropsicológica en psicología clínica*. Universidad Central de Chile.",
    },
    {
      iconName: "FaGraduationCap",
      text: "Curso: *Violencia intrafamiliar*. Universidad Central de Chile.",
    },
    {
      iconName: "FaGraduationCap",
      text: "Curso: *Entrenamiento clínico desde una mirada integral del Ser*, Doctor Erich von Bischoffshausen y Doctor Iván Canales.",
    },
    {
      iconName: "FaGraduationCap",
      text: "Curso: *La topografía de las estructuras de personalidad psicópatas, perversas y psicóticas*, Magíster y Psicoanalista Álex Droppelmann.",
    },
    {
      iconName: "FaGraduationCap",
      text: "Curso: de perfeccionamiento docente: *Evaluación de Resultados de Aprendizajes*. Universidad Autónoma de Chile.",
    },
    {
      iconName: "FaGraduationCap",
      text: "Curso: Perfeccionamiento docente: *Metodologías Activo Participativas Centradas en el Estudiante*. Universidad Autónoma de Chile.",
    },
    {
      iconName: "FaGraduationCap",
      text: "Seminario del departamento de psiquiatría clínica. Unidad de filosofía y humanidades de la Universidad de Chile: *La intuición en la práctica clínica ¿Método o arte? Fronteras entre las ciencias y las humanidades*. Facultad de Medicina.",
    },
    {
      iconName: "FaGraduationCap",
      text: "Seminario del departamento de psiquiatría Pontificia Universidad Católica de Chile, Unidad de Trastornos de Alimentación: *Configuración psicopatológica de los trastornos de alimentación*, Doctora Patricia Cordella, Presidenta Seta Chile. Clínica San Carlos de Apoquindo, UC Christus.",
    },
    {
      iconName: "FaGraduationCap",
      text: "V Seminario internacional: *Crisis de pareja por infidelidad, tipos y manejos terapéuticos*, Doctor Mario Zumaya. Sociedad Chilena de Psicología y Psicoterapia Constructivista.",
    },
    {
      iconName: "FaGraduationCap",
      text: "I Seminario: *Psicopatías y Perversiones*. Sociedad de Analyse Freudienne de París.",
    },
    {
      iconName: "FaGraduationCap",
      text: "Seminario: *De Freud a Lacán*, Psicoanalista Norberto Rabinovich.",
    },
    {
      iconName: "FaGraduationCap",
      text: "I Congreso internacional de terapias cognitivas constructivistas y posracionalistas: *Apego temprano, identidad personal y psicopatología*. Organizado por el Centro de Psicoterapia Cognitiva - Posracionalista (Cetepo, Argentina). Realizado en la Universidad de Buenos Aires. (Buenos Aires, Argentina).",
    },
    {
      iconName: "FaGraduationCap",
      text: "XXIII Congreso Nacional de Psicología Clínica: *Temas emergentes en el SXXI*. Organizado por la Sociedad Chilena de Psicología Clínica (SCPC). Realizado en la Universidad Autónoma de Chile, sede Providencia. (Santiago, Chile).",
    },
  ],
};

export default jorgeData;
